/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Orgs_EmptyInputs */

const cs_portal_orgs_empty = /** @type {(inputs: Portal_Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tento účet nejsou dostupné žádné organizace.`)
};

const en_portal_orgs_empty = /** @type {(inputs: Portal_Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organizations available for this account.`)
};

/**
* | output |
* | --- |
* | "No organizations available for this account." |
*
* @param {Portal_Orgs_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_orgs_empty = /** @type {((inputs?: Portal_Orgs_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Orgs_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_orgs_empty(inputs)
	return cs_portal_orgs_empty(inputs)
});